import Vue from 'vue';

export default Vue.extend({
  template: `
  <select 
    ref="selectRef"
    style="padding: 5px; padding-right: 130px;"
    v-model="editorState"
    @change="onChange()"
  >
    <option
      v-for="value of selectOptions"
      :value="value"
      >{{value}} 
    </option> 
  </select>`,

  data() {
    return {
        field: this.params.colDef.field,
        editorState: this.params.value,
        selectOptions: this.params.values,
    };
  },
  watch: {
    'params.value': {
        immediate: true,
        deep: true,
        handler(value) { 
            if(value) {
                this.editorState = this.params.value
            this.$forceUpdate()
            }
        }
    },
    'params.values': {
        immediate: true,
        deep: true,
        handler(value) { 
            if(value) {
                this.selectOptions = this.params.values
                this.$forceUpdate()
            }
        }
    },
    'params.colDef.field': {
        immediate: true,
        deep: true,
        handler(value) {
            if(value) {
                this.field = this.params.colDef.field
                this.$forceUpdate()
            }
        }
    },
  },
  methods: {
    onChange() {
      // select next cell after updateing the value
      let refs = this.params.context.editorRefs;
      let childSelect = refs[this.field + 'SelectRef'];
      if (!childSelect) return;
      childSelect.focus();
    },

    updateRefData(newParentCellValue) {
      // columns that have property - cascadeFrom
      // will expose this method for updating
      const { getRefData } = this.params.context;
      this.editorState = getRefData(newParentCellValue)[0];
      this.selectOptions = getRefData(newParentCellValue);
    },

    getValue() {
      return this.editorState;
    },

    isCancelBeforeStart() {
      return false;
    },

    isCancelAfterEnd() {
      return false;
    },
  },

  updated() {
    const editorUpdateMethod = this.params.context.editorUpdateMethods[
      this.field + 'Update'
    ];

    if (!editorUpdateMethod) {
      return;
    }
    // parent cell editor will call child cell editor exposed update method
    editorUpdateMethod(this.editorState);
  },


  mounted() {
    //this.field = this.params.colDef.field;
    console.log("this.params ", this.params)
    const { cascadeFrom, context, focusOnEditStart } = this.params;
    
    if (cascadeFrom) {
      // saving ref to child select
      context.editorRefs[cascadeFrom + 'SelectRef'] = this.$refs.selectRef;
      //  exposing update functions for clomuns that have a parent column
      context.editorUpdateMethods[cascadeFrom + 'Update'] = this.updateRefData;
    }

    this.$nextTick(() => {
      // i provided a property to country coll so the editor knows what to focus firs
      if (focusOnEditStart) this.$refs.selectRef.focus();
    });
  },
});
